import { useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/index';
import { setEditingName } from 'store/slices/profileSlice';
import { calcSizeForDevice } from 'utils/index';

import { ProfileNameField } from 'components/Profile/Form/NameField';
import { ProfileActionBar } from 'components/Profile/Form/ProfileActionBar';
import TvKeyboard from 'components/TvKeyboard';
import { WebDiv } from 'components/WebDiv';

const MIN_NAME = 3;
const MAX_NAME = 30;

type ProfileEditNameScreenProps = {
  onClose: () => void;
};

const ProfileEditNameScreen = ({ onClose }: ProfileEditNameScreenProps) => {
  const dispatch = useDispatch();

  const editingProfile = useSelector((state: RootState) => state.profile.editingProfile);

  const [name, setName] = useState(editingProfile?.name ?? '');
  const [hasError, setHasError] = useState<boolean>(false);

  const handleConfirm = () => {
    const trimmed = name.trim();

    if (trimmed.length < MIN_NAME) {
      setHasError(true);
      return;
    }

    dispatch(setEditingName(trimmed));
    onClose();
  };

  const handleChangeName = (text: string) => {
    if (text.length > MAX_NAME) return;

    setName(text);

    if (text.trim().length >= MIN_NAME) setHasError(false);
  };

  return (
    <WebDiv className="navigation-container navigation-priority">
      <View style={styles.container}>
        <WebDiv className="navigation-ignore">
          <View style={styles.nameField}>
            <ProfileNameField
              value={name}
              onChange={handleChangeName}
              hasError={hasError}
              maxLength={MAX_NAME}
              showCounter
            />
          </View>
        </WebDiv>
        <View>
          <WebDiv className="navigation-container navigation-grid">
            <TvKeyboard
              variant="alphabet"
              appearance="strong"
              textValue={name}
              setTextValue={handleChangeName}
            />
          </WebDiv>
          <View style={styles.actionBarContainer}>
            <ProfileActionBar onConfirm={handleConfirm} onCancel={onClose} />
          </View>
        </View>
      </View>
    </WebDiv>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    marginTop: calcSizeForDevice(71),
    justifyContent: 'center',
  },
  nameField: {
    width: calcSizeForDevice(538),
    marginRight: calcSizeForDevice(45),
  },
  actionBarContainer: {
    marginTop: calcSizeForDevice(16),
    marginLeft: calcSizeForDevice(5),
  },
});

export default ProfileEditNameScreen;
